import React, {useEffect} from 'react';
import {
    requestGetCddJobNote,
    requestSaveCddJobNote,
    requestSearchCddJobOverview
} from '@pages/dvtjcuv/service/DVTJCUVService';
import {ResponseCode} from '@app/constants/Common';
import {showSuccessMessageSaveData} from '@pages/candidate/Common';

const InitNote = {
    matching_note: '',
    cdd_id: ''
}

const DVTJCUVSearchCddJobNotes = (props) => {
    const [searchCddJobNote, setSearchCddJobNote] = React.useState(InitNote);
    const {cddId} = props

    const fetchMatchingNotes = async (canId) => {
        const res = await requestGetCddJobNote(canId);
        if (res.sts_code === ResponseCode.SUCCESS) {
            setSearchCddJobNote(res.content)
        } else {
            setSearchCddJobNote({})
        }
    }

    const saveMatchingNotes = async () => {
        searchCddJobNote.cdd_id = cddId
        const res = await requestSaveCddJobNote(searchCddJobNote)
        showSuccessMessageSaveData(res.sts_code)
    }

    const onSave = async () => {
        await saveMatchingNotes()
    }

    useEffect(() => {
        fetchMatchingNotes(cddId)
    }, [cddId]);

    const onChangeInput = (event) => {
      setSearchCddJobNote({...searchCddJobNote, [event.target.name]: event.target.value})
    }

    return (
        <>
            <div className="card card-default">
                <div className="card-header">
                    <h3 className="card-title text-bold">Matching Notes</h3>
                    <button type="button" className="btn btn-tool" data-card-widget="collapse">
                        <i className="fas fa-minus" />
                    </button>
                    <div className="card-tools pr-2">
                        <button
                            type='button'
                            className='btn btn-primary'
                            onClick={onSave}
                        >
                            Save
                        </button>
                    </div>
                </div>
                <div className="card-body">
                    <textarea
                        name={'matching_note'}
                        value={searchCddJobNote.matching_note}
                        onChange={(e) => onChangeInput(e)}
                        className="form-control"
                        defaultValue=""
                    />
                </div>
            </div>
        </>
    )
}

export default DVTJCUVSearchCddJobNotes;
